import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getFamilyFestFaqQuestionsByCategoryIdAsync, getFamilyFestFaqQuestionByIdAsync, createFamilyFestFaqQuestionAsync, updateFamilyFestFaqQuestionAsync, deleteFamilyFestFaqQuestionAsync, reorderFamilyFestFaqQuestionsAsync } from './familyFestFaqQuestionThunk';
const initialState = {
    status: APIStatus.IDLE,
    faqQuestions: [],
    selectedFaqQuestion: null
};
export const familyFestFaqQuestionSlice = createSlice({
    name: 'familyFestFaqQuestion',
    initialState,
    reducers: {
        clearSelectedFamilyFestFaqQuestion: (state) => {
            state.selectedFaqQuestion = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFamilyFestFaqQuestionsByCategoryIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestFaqQuestionsByCategoryIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.faqQuestions = action.payload;
        })
            .addCase(getFamilyFestFaqQuestionsByCategoryIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFamilyFestFaqQuestionByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestFaqQuestionByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedFaqQuestion = action.payload;
        })
            .addCase(getFamilyFestFaqQuestionByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createFamilyFestFaqQuestionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFamilyFestFaqQuestionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                state.faqQuestions = [...state.faqQuestions, ...action.payload.data];
            }
        })
            .addCase(createFamilyFestFaqQuestionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateFamilyFestFaqQuestionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFamilyFestFaqQuestionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                const updatedQuestion = action.payload.data;
                const index = state.faqQuestions.findIndex((q) => q.id === updatedQuestion.id);
                if (index !== -1)
                    state.faqQuestions[index] = updatedQuestion;
                if (state.selectedFaqQuestion?.id === updatedQuestion.id) {
                    state.selectedFaqQuestion = updatedQuestion;
                }
            }
        })
            .addCase(updateFamilyFestFaqQuestionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteFamilyFestFaqQuestionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteFamilyFestFaqQuestionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                const deletedId = action.payload.data.id;
                state.faqQuestions = state.faqQuestions.filter((q) => q.id !== deletedId);
                if (state.selectedFaqQuestion?.id === deletedId) {
                    state.selectedFaqQuestion = null;
                }
            }
        })
            .addCase(deleteFamilyFestFaqQuestionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(reorderFamilyFestFaqQuestionsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(reorderFamilyFestFaqQuestionsAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(reorderFamilyFestFaqQuestionsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearSelectedFamilyFestFaqQuestion } = familyFestFaqQuestionSlice.actions;
export default familyFestFaqQuestionSlice.reducer;
